import { store } from '@redux/store';
import fastdom from 'fastdom';
import { onArticleCountResultsLoaded$, selectSearchTerm } from 'features/articleSearchResultsFacets';

/**
 * Updates the breadcrumb navigation to display the current search term.
 * @function
 */
const updateBreadcrumb = function() {
    const breadcrumbListElement = document.querySelector('[data-breadcrumb-list]');

    if(breadcrumbListElement){
        const searchTerm = selectSearchTerm(store.getState());
        const lastElement = breadcrumbListElement.querySelector('[data-last-element]');
        fastdom.mutate(() => {
            if(searchTerm && lastElement){
                lastElement.innerHTML = searchTerm;
            }
        });
    } 
};
    
onArticleCountResultsLoaded$.subscribe(updateBreadcrumb);